import React from 'react';
import { motion } from 'framer-motion';
import { SectionLabel, PrimaryButton, SecondaryButton } from './ui/UI';
const delivers = [{
  title: 'Validated paths',
  body: 'Not 500 findings. The paths that actually lead to business impact in your environment — with the evidence behind each one.'
}, {
  title: 'Control verdicts',
  body: 'Which of your EDR, SIEM, MFA, WAF, identity, and posture tools detected, blocked, logged, alerted — and which missed entirely.'
}, {
  title: 'Top fixes',
  body: 'The fixes that close the most paths first, mapped to the ticketing systems and owners your team already uses.'
}, {
  title: 'Verification plan',
  body: 'How Periscan will re-test once the fix lands. Closed tickets are not the finish line — closed paths are.'
}, {
  title: 'Evidence appendix',
  body: 'A summary your team, customers, auditors, insurers, or board can read without a decoder ring. And a technical appendix for the people who want one.'
}];
export function ValidationSnapshot() {
  return <section id="validation-snapshot" aria-labelledby="snapshot-heading" className="relative w-full py-32 border-t border-white/5 scroll-mt-24" data-id="element-1358">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-1359">
        <SectionLabel number="01" label="See a Validation Snapshot" className="mb-8" data-id="element-1360" />

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-20" data-id="element-1361">
          <div className="lg:col-span-8" data-id="element-1362">
            <motion.h2 id="snapshot-heading" initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.6
          }} className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-semibold tracking-[-0.02em] leading-[1.05] text-white" data-id="element-1363">
              See what Periscan proves
              <br data-id="element-1364" />
              <span className="text-white/40" data-id="element-1365">in the first report.</span>
            </motion.h2>
          </div>
          <div className="lg:col-span-4 lg:pt-4" data-id="element-1366">
            <p className="text-lg text-white/65 leading-relaxed" data-id="element-1367">
              The Validation Snapshot is the first Periscan proof moment:
              validated exposure paths, control observations, remediation
              priorities, verification steps, and evidence your team can share.
            </p>
          </div>
        </div>

        <ol className="border-t border-white/5 mb-16" data-id="element-1368">
          {delivers.map((d, i) => <motion.li key={d.title} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.05
        }} className="border-b border-white/5 py-10 grid grid-cols-12 gap-6 items-baseline" data-id="element-1369">
              <span className="col-span-12 md:col-span-1 font-mono text-sm text-[#1a8fd4]/70 tracking-[0.2em]" data-id="element-1370">
                {String(i + 1).padStart(2, '0')}
              </span>
              <h3 className="col-span-12 md:col-span-4 text-2xl md:text-3xl text-white font-semibold tracking-tight leading-snug" data-id="element-1371">
                {d.title}
              </h3>
              <p className="col-span-12 md:col-span-7 text-base md:text-lg text-white/65 leading-relaxed max-w-2xl" data-id="element-1372">
                {d.body}
              </p>
            </motion.li>)}
        </ol>

        <div className="flex flex-wrap items-center gap-4" data-id="element-1373">
          <PrimaryButton href="#" size="lg" data-id="element-1374">
            Coming Soon
          </PrimaryButton>
          <SecondaryButton href="/sample-report" size="lg" data-id="element-1375">
            View Sample Snapshot
          </SecondaryButton>
        </div>
      </div>
    </section>;
}